<div class="pl-page" [class.pl-page--dialog]="dialogRef">

  <!-- ── LOADING ──────────────────────────────────────────────── -->
  <div class="pl-loading" *ngIf="!ready">
    <div class="pl-loading__icon"><mat-icon>account_balance</mat-icon></div>
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    <p class="pl-loading__text">Cargando formulario…</p>
  </div>

  <ng-container *ngIf="ready">

    <!-- ── HEADER (modo página) ───────────────────────────────── -->
    <div class="pl-header" *ngIf="!dialogRef">
      <div class="pl-header__icon"><mat-icon>account_balance</mat-icon></div>
      <div>
        <h1 class="pl-header__title">{{ prestamos.uid ? 'Editar préstamo' : 'Nuevo préstamo bancario' }}</h1>
        <p class="pl-header__sub">{{ prestamos.uid ? 'Modifica los datos del préstamo' : 'Registra un nuevo préstamo' }}</p>
      </div>
      <button mat-flat-button class="pl-btn-save" (click)="save()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

    <!-- ── HEADER (modo dialog) ──────────────────────────────── -->
    <div mat-dialog-title class="pl-dlg-title" *ngIf="dialogRef">
      <div class="pl-dlg-title__left">
        <div class="pl-header__icon"><mat-icon>account_balance</mat-icon></div>
        <span>Préstamo bancario</span>
      </div>
      <button mat-icon-button (click)="closeDialog()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- ── AVISO IMPORTACIÓN ─────────────────────────────────── -->
    <div class="pl-import-notice" *ngIf="flagImport">
      <mat-icon>info</mat-icon>
      <span><strong>Importación:</strong> {{ movement.reference }}</span>
    </div>

    <!-- ── BODY ───────────────────────────────────────────────── -->
    <div class="pl-body" [class.pl-body--dialog]="dialogRef">
      <form onkeypress="return event.keyCode != 13;">
        <div class="pl-grid">

          <!-- COLUMNA IZQUIERDA -->
          <div class="pl-left">

            <!-- SECCIÓN: Identificación -->
            <div class="pl-section">
              <div class="pl-section__head">
                <mat-icon>perm_identity</mat-icon>
                <span>Identificación</span>
              </div>
              <div class="pl-section__body">

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Duración</mat-label>
                  <mat-select [(ngModel)]="prestamos.duracion" name="duracion" required>
                    <mat-option [value]="1">Corto Plazo — 520</mat-option>
                    <mat-option [value]="2">Largo Plazo — 170</mat-option>
                  </mat-select>
                </mat-form-field>

                <app-input inputType="text" placeholder="Número de préstamo" name="prestamos.numero"
                  [isRequired]="true" [(ngModel)]="prestamos.numero"></app-input>

                <app-input inputType="text" placeholder="Entidad prestamista" name="prestamos.entidad"
                  [isRequired]="true" [(ngModel)]="prestamos.entidad"></app-input>

              </div>
            </div>

            <!-- SECCIÓN: Plazos -->
            <div class="pl-section">
              <div class="pl-section__head">
                <mat-icon>date_range</mat-icon>
                <span>Plazos</span>
              </div>
              <div class="pl-section__body">

                <div class="pl-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha de constitución</mat-label>
                    <input matInput [matDatepicker]="fechaConstitucion" name="prestamos.fechaConstitucion"
                      [(ngModel)]="prestamos.fechaConstitucion" required>
                    <mat-datepicker-toggle matSuffix [for]="fechaConstitucion"></mat-datepicker-toggle>
                    <mat-datepicker #fechaConstitucion></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Plazo (meses)</mat-label>
                    <input matInput type="number" [(ngModel)]="prestamos.plazo" name="prestamos.plazo" required>
                  </mat-form-field>
                </div>

                <div class="pl-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha de finalización</mat-label>
                    <input matInput [matDatepicker]="fechaFinalizacion" name="prestamos.fechaFinalizacion"
                      [(ngModel)]="prestamos.fechaFinalizacion" required>
                    <mat-datepicker-toggle matSuffix [for]="fechaFinalizacion"></mat-datepicker-toggle>
                    <mat-datepicker #fechaFinalizacion></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Carencia (meses)</mat-label>
                    <input matInput type="number" [(ngModel)]="prestamos.carencia" name="prestamos.carencia" required>
                  </mat-form-field>
                </div>

              </div>
            </div>

          </div>

          <!-- COLUMNA DERECHA -->
          <div class="pl-right">

            <!-- SECCIÓN: Importes y condiciones -->
            <div class="pl-section">
              <div class="pl-section__head">
                <mat-icon>attach_money</mat-icon>
                <span>Importes y condiciones</span>
              </div>
              <div class="pl-section__body">

                <div class="pl-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Importe inicial</mat-label>
                    <input matInput type="text" [(ngModel)]="prestamos.importeInicial"
                      name="prestamos.importeInicial" numberDecimalsDirective required>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Importe pendiente</mat-label>
                    <input matInput type="text" [(ngModel)]="prestamos.importePendiente"
                      name="prestamos.importePendiente" numberDecimalsDirective required>
                  </mat-form-field>
                </div>

                <div class="pl-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Comisión apertura</mat-label>
                    <input matInput type="text" [(ngModel)]="prestamos.comisionApertura"
                      name="prestamos.comisionApertura" numberDecimalsDirective required>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Tipo de interés</mat-label>
                    <input matInput type="text" [(ngModel)]="prestamos.tipoInteres"
                      name="prestamos.tipoInteres" numberDecimalsDirective required>
                  </mat-form-field>
                </div>

              </div>
            </div>

            <!-- SECCIÓN: Liquidaciones y cuenta -->
            <div class="pl-section">
              <div class="pl-section__head">
                <mat-icon>account_balance_wallet</mat-icon>
                <span>Liquidaciones y cuenta</span>
              </div>
              <div class="pl-section__body">

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Tipo de liquidaciones</mat-label>
                  <mat-select [(ngModel)]="prestamos.tipoLiquidaciones" name="tipoLiquidaciones" required>
                    <mat-option [value]="0">Sin seleccionar</mat-option>
                    <mat-option [value]="1">Mensual</mat-option>
                    <mat-option [value]="2">Bimensual</mat-option>
                    <mat-option [value]="3">Trimestral</mat-option>
                    <mat-option [value]="4">Semestral</mat-option>
                    <mat-option [value]="5">Anual</mat-option>
                  </mat-select>
                </mat-form-field>

                <app-autocomplete-select [items]="bankAccounts"
                  [(selectedItemId)]="prestamos.bankAccountsUid"
                  [idField]="'uid'" [displayFields]="['bank', 'iban']"
                  placeholder="Cuenta de adeudo" class="w-100">
                </app-autocomplete-select>

              </div>
            </div>

          </div>

        </div>
      </form>
    </div>

    <!-- ── ACTIONS (modo dialog) ────────────────────────────── -->
    <mat-dialog-actions align="end" *ngIf="dialogRef">
      <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
      <button mat-flat-button class="pl-btn-save" (click)="save()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </mat-dialog-actions>

  </ng-container>

</div>
